// extracted by mini-css-extract-plugin
export default {"root":"WebPushBubble__root--1bHNi","text":"WebPushBubble__text--3GDc9","buttons":"WebPushBubble__buttons--2syXC","target":"WebPushBubble__target--mQxeJ"};